
import AppTotals from "./SaleEditTotals.vue";
import AppRecoveryInfo from "./SaleRecoveryInfo.vue";
import Vue from "vue";
import { SaleEditState } from "../../utils/sale-edit/sale-edit-state";
import AppBreadcrumb from "./SaleEditBreadcrumb.vue";
import AppProperties from "./SaleEditProperties.vue";
import AppSaveModal from "./SaleEditSaveModal.vue";
import AppTicketRefundModal from "../cashier/TicketRefundModal.vue";
import AppLoyaltyRedeemModal from "./LoyaltyRedeemModal.vue";
import AppTable from "./SaleEditTable.vue";
import AppSendModal from "./SaleSendModal.vue";
import AppBankEdit from "@/components/bank/QuickEdit.vue";
import AppSaleEditAwsDocuments from "./SaleEditAwsDocuments.vue";
import AppSalePdfPreview from "@/components/sales/SalePdfPreview.vue";
import AppSaleRowSearchBrowse from "@/components/sales/SaleRowSearchBrowse.vue";
import { View } from "@/models/view";
import { HumanFilter } from "@/utils/human-filter";
import { ViewColumn } from "@/utils/views/view-column";
import { getModel } from "@/utils/models/model";
import { SaleLayoutConf } from "@/models/sale-layout";
import { SaleService } from "@/services/sale-service";
import { PrintContext } from "@/utils/sale-layouts/print-settings";
import {UserConfigService} from "@/services";

export default Vue.extend({
	data(){
		return {
			layout: new SaleLayoutConf(),
		};
	},
	props: {
		state: {
			type: Object as () => SaleEditState,
			required: true
		}
	},
	computed: {
		saleRowView():View {
			let v = new View();
			v.Table = "SaleRow";
			v.BrowseID = 7;
			v.Columns = this.saleRowViewColumns;
			v.HumanFilters = [
				new HumanFilter({Field: "this_Sale.ContactID", Operator: "=", Values: [`${this.state.sale.ContactID}`]}),
				new HumanFilter({Field: "this.ProductSku", Operator: "=", Values: [`${this.state.productEditRowState.product?.Sku}`]}),
			];
			return v;
		},
		saleRowViewColumns():ViewColumn[]{
			let model = getModel("SaleRow");
			return [
				ViewColumn.makeQuickViewColumn("Amount", model, "80px"),
				ViewColumn.makeQuickViewColumn("Sale.Type.Name", model, "100px"),
				ViewColumn.makeQuickViewColumn("Sale.ComputedFriendlyID", model, "100px"),
				ViewColumn.makeQuickViewColumn("Sale.InvoiceDate", model, "100px"),
				ViewColumn.makeQuickViewColumn("ProductSku", model, "100px"),
				ViewColumn.makeQuickViewColumn("ProductDescription", model, "200px"),
				ViewColumn.makeQuickViewColumn("UnitPrice", model, "100px"),
				ViewColumn.makeQuickViewColumn("Discount", model, "50px"),
				ViewColumn.makeQuickViewColumn("TotalPriceExcVat", model, "100px"),
			];
		},
		sendWithExtraPrintOptions():boolean {
			if (!this.state.config) return false;
			return this.state.config.AskForExtraPrintOptionsOnSave;
		},
		showSaleRecovery():boolean {
			return UserConfigService.getSaleSettings().ShowSaleRecovery;
		}
	},
	watch: {
		async "state.sale.LayoutID"(){
			this.layout = await SaleService.getSaleLayout(this.state.sale.getLayoutID(PrintContext.DOWNLOAD));
		},
		"state.saveModalOpen"(value: boolean) {
			this.state.sale.Rows.forEach((row, index) => {
				row.DisplayOrder = index;
			});
		}
	},
	methods: {
		saleComplete() {
			let callBackTask = this.state.callBackTask;
			this.state.bankEditOpen = false;
			this.state.clearNotifier();
			this.state.runCallbackTask();
			if (callBackTask !== "openSendModal") {
				this.state.closeEditModal();
				this.state.onFinish();
			}
		}
	},
	created(){

	},
	components: {
		AppBreadcrumb,
		AppProperties,
		AppTable,
		AppTotals,
		AppSaveModal,
		AppTicketRefundModal,
		AppLoyaltyRedeemModal,
		AppSendModal,
		AppBankEdit,
		AppSaleEditAwsDocuments,
		AppSaleRowSearchBrowse,
		AppSalePdfPreview,
		AppRecoveryInfo,
	}
});
